/**
 * Parcels Receipt
 */

// React
import React, { useEffect, useState } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../redux/reducers';

// Selector
import { createStructuredSelector } from 'reselect';
import { makeSelectLoading, makeSelectError, makeSelectAllPostOrders } from '../../orders/selectors';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { WrapperReceipt } from './style';

// Helper
import { useQuery, translate } from '../../../utils/helpers';

// Type
import { SelectorProps, Props } from './interfaces';
import Barcode from 'react-barcode';
import { Payload } from '../../orders/interfaces';
import { getPostOrdersAction } from '../../orders/actions';
import { useLocation } from 'react-router-dom';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(-8),
        },
      },
    },
  })
);

export function Details(props: Props) {
  const query = useQuery(useLocation);

  const classes = useStyles();
  const [parcelItemsPage, setParcelItemsPage] = useState<any>([]);

  const setLoopPage = (items: any) => {
    const loopItems = [];
    for (let i = 0; i < Math.ceil(items.length / 10); i++) {
      loopItems.push(i + 1);
    }
    setParcelItemsPage(loopItems);
  };

  useEffect(() => {
    const filters = query.get('filters');
    const filtersValues = JSON.parse(String(filters));
    const greaterThanOrEqual = filtersValues['updated.greaterThanOrEqual']?.toString()?.replace(" ", "+");
    const lessThanOrEqual = filtersValues['updated.lessThanOrEqual']?.toString()?.replace(" ", "+");
    props.ordersDispatch({
      ...filtersValues,
      'updated.greaterThanOrEqual': greaterThanOrEqual,
      'updated.lessThanOrEqual': lessThanOrEqual,
      deliveryType: { notEquals: 'COURIER' },
      orderStatus: { equals: 'DELIVERED_TO_POST' },
      status: { equals: 'DONE' },
      page: 0,
      size: 1000,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (parcelItemsPage.length) {
      window.print();
    }
  }, [parcelItemsPage]);

  useEffect(() => {
    if (props.ordersList.length) {
      setLoopPage(props.ordersList);
    }
  }, [props.ordersList]);

  return (
    <WrapperReceipt className={classes.root}>
      {parcelItemsPage.map((parcelItem: any, itemIndex: number) => {
        return (
          <div className="page">
            <div className=" wrapper ">
              {/*Section 1 */}
              <div
                className="flex"
              >
                <div className="flex flex-column w-100">
                  <div className="flex justify-content-center align-items-center w-100">
                    <div className="logo-box">
                      <div>
                        <img src="/logo-dark.svg" alt="logo" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Section 3 */}
              <div className="title">
                سفارشات پستی
              </div>

              <div className="card-b">
                <div className="card-b_box">
                  <div className="card-b_header-box">
                    <div className="card-b_header">
                      <div className="card-b_header-item">ردیف</div>
                      <div className="card-b_header-item">بارکد</div>
                      <div className="card-b_header-item">شهر مقصد</div>
                      <div className="card-b_header-item">نام گیرنده</div>
                      <div className="card-b_header-item">نوع ارسال - نوع بسته</div>
                      <div className="card-b_header-item">وزن</div>
                      <div className="card-b_header-item">هزینه پستی</div>
                    </div>
                  </div>
                  <div className="card-b_content">
                    {props.ordersList?.map((item: any, index: number) => {
                      if (
                        (parcelItem - 1) * 10 <= index &&
                        index < parcelItem * 10
                      ) {
                        return (
                          <div className="card-b_content-row">
                            <div className="card-b_content-item">
                              {index + 1}
                            </div>
                            <div className="card-b_content-item">
                              <div style={{ width: '100%' }}>
                                <Barcode
                                  height={'52px'}
                                  fontSize={9}
                                  value={item.barcode}
                                />
                              </div>
                            </div>
                            <div className="card-b_content-item">
                              {item.postCity}
                            </div>
                            <div className="card-b_content-item">
                              {item.customerName}
                            </div>
                            <div className="card-b_content-item">
                              {translate(item.serviceType, 'service')}
                              {' - '}
                              {translate(item.parcelType, 'parcel')}
                            </div>
                            <div className="card-b_content-item">{item.postWeight}{' '}{'گرم'}</div>
                            <div className="card-b_content-item">{item.totalPrice}{' '}{'ریال'}</div>
                          </div>
                        );
                      }
                    })}
                  </div>
                </div>
              </div>

              {/* Section Last */}
              <div className="sing-box">
                <div className="item">
                  <span>امضا تحویل دهنده</span>
                  <span>:تاریخ</span>
                </div>
                <div className="item">
                  <span>امضا تحویل گیرنده</span>
                  <span>:تاریخ</span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </WrapperReceipt>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectAllPostOrders(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ordersDispatch: (payload: Payload) => dispatch(getPostOrdersAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
